{
  "$schema": "../extension_schema.json",
  "name": "reviewed",
  "enabled": true,
  "contextCharacteristics": [
    {
      "kind": "Asset",
      "eventTimeRepresentation": "capsule",
      "proxyKind": "leaf",
      "allowableValues": [false, true],
      "defaultValue": false
    },
    {
      "kind": "Condition",
      "eventTimeRepresentation": "capsule",
      "proxyKind": "leaf",
      "defaultValue": false,
      "allowableValues": [false, true]
    },
    {
      "kind": "Capsule",
      "eventTimeRepresentation": "capsule",
      "proxyKind": "leaf",
      "defaultValue": false,
      "allowableValues": [false, true]
    }
  ],
  "uiConfig": {
    "columns": [
      {
        "aggFunc": "Aggregated",
        "colDefDefaultValue": false,
        "aggFuncDefaultValue": false,
        "colDefDefaultFilter": ["false"],
        "colDefMinWidth": 110,
        "colDefMaxWidth": 150,
        "colDefName": "Reviewed",
        "colDefType": "boolean",
        "colDefFilterType": "set",
        "onClickAction": "toggleState",
        "valueGetter": {
          "reviewedState": {
            "identifier": "reviewed",
            "createdField": "timeCreated",
            "updatedColumn": "Time Updated"
          }
        },
        "discreteStates": [
          {
            "testId": "Not Reviewed",
            "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.NOT_REVIEWED",
            "value": false,
            "icon": "svgpath:M 19 2.76 L 18.016 4.066 L 7.678 17.765 L 6.745 19 L 5.812 17.765 L 0.984 11.373 L 0 10.067 L 1.867 7.307 L 2.851 8.613 L 6.745 13.771 L 16.149 1.306 L 17.133 0 L 19 2.76 Z",
            "iconFill": "white"
          },
          {
            "testId": "Reviewed",
            "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.REVIEWED",
            "value": true,
            "icon": "svgpath:M 19 2.76 L 18.016 4.066 L 7.678 17.765 L 6.745 19 L 5.812 17.765 L 0.984 11.373 L 0 10.067 L 1.867 7.307 L 2.851 8.613 L 6.745 13.771 L 16.149 1.306 L 17.133 0 L 19 2.76 Z"
          },
          {
            "testId": "Stale",
            "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.STALE",
            "value": "stale",
            "icon": "svgpath:M 0 0 L 0 20 L 20 20 L 20 0 Z"
          }
        ]
      }
    ],
    "iconRepresentation": {
      "onClickAction": "toggleState",
      "defaultRepresentation": false,
      "discreteStates": [
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.UNREVIEW",
          "value": true,
          "icon": "svgpath:M 19 2.76 L 18.016 4.066 L 7.678 17.765 L 6.745 19 L 5.812 17.765 L 0.984 11.373 L 0 10.067 L 1.867 7.307 L 2.851 8.613 L 6.745 13.771 L 16.149 1.306 L 17.133 0 L 19 2.76 Z",
          "nextToggleValue": false,
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.MARKED_AS_REVIEWED"
        },
        {
          "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.REVIEW",
          "value": false,
          "icon": "svgpath:M 19 2.76 L 18.016 4.066 L 7.678 17.765 L 6.745 19 L 5.812 17.765 L 0.984 11.373 L 0 10.067 L 1.867 7.307 L 2.851 8.613 L 6.745 13.771 L 16.149 1.306 L 17.133 0 L 19 2.76 Z",
          "iconFill": "white",
          "nextToggleValue": true,
          "tooltipTemplateTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.MARKED_AS_UNREVIEWED"
        }
      ],
      "mixedStates": {
        "labelTranslationKey": "VANTAGE.EXTENSIONS.REVIEWED.REVIEW",
        "value": false,
        "icon": "svgpath:M 19 2.76 L 18.016 4.066 L 7.678 17.765 L 6.745 19 L 5.812 17.765 L 0.984 11.373 L 0 10.067 L 1.867 7.307 L 2.851 8.613 L 6.745 13.771 L 16.149 1.306 L 17.133 0 L 19 2.76 Z",
        "iconFill": "white",
        "nextToggleValue": true
      }
    },
    "consoleToolbarConfiguration": {
      "sortOrder": 2,
      "onClick": "toggleNextState"
    }
  }
}
